<template>
<div :class="classModal">
			<div class="modal-background"></div>
  			<div class="modal-card">
	    		<header class="modal-card-head">
				      <p class="title is-5">{{title}}</p>				      
				</header>
				<section class="modal-card-body  ssection">
                    <s-l :id="id"><slot></slot></s-l>
				</section>
				<footer class="modal-card-foot" >
      				<div style="width:80%;margin-left:10%">
      					<div style="float:left">
                             <label class="checkbox">
                                <input type="checkbox" v-model="check">
                                    Ne plus m'afficher ce message
                                </label>
      					</div>
      					<div style="float:right">
      						<s-button  theme="button is-success" label="OK" icon="thumbs-up" @onclick="yes"></s-button>      						
      					</div>
      				</div>
    			</footer>
  			</div>
  			
			</div>
		</div>
</template>
<style scoped>
    .ssection {
        color: black;
        font-size: 20px;
    }
</style>
<script>
    import firebase_api from "@/firebase/firebase_api"
	export default  {
		props: ["title", "id"],
		data() {
			return {
                classModal: "modal is-active",
                check: false
			}
		},
		watch: {
            check: function(val) {
                if (val) 
                    this.checkHelp(false);
                else
                     this.checkHelp(true);
            }
		},
		methods: {
			yes () {
				 this.classModal = "modal";	
			},
			checkHelp (bool) {
                if (this.$store.getters.getUser.help!="undefined") {
                    var help = {};
                } 
                else {
                    var help = this.$store.getters.getUser.help;
                }
                help[this.id] = bool;
                firebase_api.api.getDb().collection("user").doc(this.$store.getters.getUser.id).update({
                    help: help
                }).then(()=>{
                    this.$store.dispatch('init', ()=>{});
                })
			}
			
        },
        mounted() {
           
            if (typeof(this.$store.getters.getUser.help)=="undefined") {
                this.classModal = "modal is-active";
            }
            else if (this.$store.getters.getUser.help[this.id] == false)
               this.classModal = "modal";
        }
	}
</script>